import React, { useEffect, useState } from 'react';
import { Helpers } from "../helpers/Helpers";
import { GetBankAccountTransactionListPagingAndFilterResponseItem } from "../models/response/bankAccountTransaction/GetBankAccountTransactionListPagingAndFilterResponse";
import Box from "./Box";
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../redux/reducers/authSlice';
import { useDispatch } from 'react-redux';
import { BankAccountTransactionService } from '../services/BankAccountTransactionService';
import { GetBankMovementPopUpResponse, GetBankMovementPopUpResponseCustomField, GetBankMovementPopUpResponseData } from '../models/response/bankAccountTransaction/GetBankMovementPopUpResponse';
import CustomSingleSelect, { CustomSingleSelectModel } from './CustomSingleSelect';
import CustomMultiSelect from './CustomMultiSelect';
import { CompanyService } from '../services/CompanyService';
import { GetCompanyListResponse } from '../models/response/company/GetCompanyListResponse';
import { GetCaseListResponse } from '../models/response/case/GetCaseListResponse';
import { CaseService } from '../services/CaseService';
import { GetBankAccountListResponse } from '../models/response/bankAccount/GetBankAccountListResponse';
import { BankAccountService } from '../services/BankAccountService';
import { AddEntityCustomFieldRequest, AddEntityCustomFieldRequestCustomField } from '../models/request/bankAccountTransaction/AddEntityCustomFieldRequest';
import { AddEntityCustomFieldResponse } from '../models/response/bankAccountTransaction/AddEntityCustomFieldResponse';

interface Props {
    setSelectedItem: React.Dispatch<React.SetStateAction<GetBankAccountTransactionListPagingAndFilterResponseItem | undefined>>
    selectedItem: GetBankAccountTransactionListPagingAndFilterResponseItem
    customCallback: () => void
}

const BankMovementPopUp = ({ selectedItem, setSelectedItem, customCallback }: Props) => {
    const dispatch = useDispatch();
    const [data, setData] = useState<GetBankMovementPopUpResponseData | undefined>(undefined);

    useEffect(() => {
        getData([], selectedItem.bankAccountTransactionId, true);
    }, [])

    const customValidate = (_currencyCode: string, _itemId: number) => {
        if (_currencyCode == 'TRY' && [6, 12].includes(_itemId)) {
            return false;
        }

        return true;
    }

    const save = async () => {
        try {
            if (data && data.customFields.length > 0) {
                for (var i = 0; i < data.customFields.length; i++) {
                    if (Helpers.isEmpty(data.customFields[i].value)) {
                        toast.error('Lütfen boş alan bırakmayınız!')
                        return;
                    }
                }

                dispatch(storeActivityIndicator(true));

                var customFormId = data.customFields[0].customFormId;
                var customFieldList: AddEntityCustomFieldRequestCustomField[] = [];

                for (var i = 0; i < data.customFields.length; i++) {
                    customFieldList.push({ customFieldId: data.customFields[i].id, value: data.customFields[i].value + '' })
                }

                var obj: AddEntityCustomFieldRequest = {
                    customFields: customFieldList,
                    customFormId: customFormId,
                    entityId: selectedItem.bankAccountTransactionId
                }

                var response: AddEntityCustomFieldResponse = await BankAccountTransactionService.addEntityCustomField(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)
                setSelectedItem(undefined);
                customCallback();
            }
            else {
                toast.error('Lütfen boş alan bırakmayınız!')
                return;
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const getData = async (selectedIds: string[], entityId: string, isFirstTime: boolean) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: GetBankMovementPopUpResponse = await BankAccountTransactionService.getBankMovementPopUp(selectedIds, entityId, isFirstTime);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            for (var i = 0; i < response.data.customFields.length; i++) {
                var item = response.data.customFields[i];
                var opponent = response.data.entityCustomFields.find(x => x.customFieldId == item.id);

                response.data.customFields[i].value = opponent?.value;

                if (item.dataType == "Select") {
                    var opponent = response.data.entityCustomFields.find(x => x.customFieldId == item.id);

                    var items: CustomSingleSelectModel[] = [];

                    if (Helpers.isEmpty(item.defaultValues)) {
                        if (item.ajaxUrl == '/Customer/GetAll') {
                            var response2: GetCompanyListResponse = await CompanyService.getCompanyList({});

                            if (!response2.isSuccess) {
                                toast.error(response2.message)
                                return;
                            }

                            items = response2.data.map(function (x) {
                                return { label: x.name, value: x.companyId }
                            })
                        }
                        else if (item.ajaxUrl == '/IntegrationBankAccount/GetAllWithCase') {
                            var response3: GetCaseListResponse = await CaseService.getCaseList();

                            if (!response3.isSuccess) {
                                toast.error(response3.message)
                                return;
                            }

                            items = [...items, ...response3.data.map(function (x) {
                                return { label: x.name, value: x.caseId, additionalValue1: 'C' }
                            })];

                            var response4: GetBankAccountListResponse = await BankAccountService.getBankAccountList();

                            if (!response4.isSuccess) {
                                toast.error(response4.message)
                                return;
                            }

                            items = [...items, ...response4.data.map(function (x) {
                                return { label: x.name, value: x.bankAccountId, additionalValue1: 'B' }
                            })];
                        }
                        else {
                            alert('NOT FOUND');
                        }
                    }
                    else {
                        items = item.defaultValues.split(';').map(function (x: string) {
                            return { label: x, value: x }
                        })
                    }

                    if (opponent && opponent.value) {
                        var selectedObj = items.find(x => x.value == opponent?.value);

                        if (selectedObj)
                            response.data.customFields[i].selectedValue = selectedObj;
                    }

                    response.data.customFields[i].items = items;
                }
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const getSelectedRadioItems = (_ind: number) => {
        var vals = [];

        var checkedNames = [...document.querySelectorAll("*[name*='inlineRadioOptions-']")].map(function (x: any) {
            return x.name;
        })

        checkedNames = [...new Set(checkedNames)];

        for (var i = 0; i < checkedNames.length; i++) {
            var o: any = document.querySelector("*[name='" + checkedNames[i] + "']:checked");
            var tempVal = o?.value;

            if (i <= _ind && tempVal)
                vals.push(tempVal);
        }

        getData(vals, selectedItem.bankAccountTransactionId, false);
    }

    const onCustomSelectChange = (selectedValue: CustomSingleSelectModel | undefined, item: GetBankMovementPopUpResponseCustomField) => {
        if (data) {
            setData({
                ...data,
                customFields: data.customFields.map(function (x) {
                    if (x.id == item.id) {
                        x.value = selectedValue ? selectedValue.value : '';
                        x.selectedValue = selectedValue;
                    }

                    if (item.customId == 23 && x.customId == 22) {
                        if (selectedValue) {
                            var amount = parseFloat(Math.abs(data.bankAccountTransaction.amount).toString().replace(",", "."));
                            var taxRate = parseInt(selectedValue.value.replace('%', ''));
                            var newTaxAmount = ((amount / 100) * taxRate).toFixed(2);
                            x.value = newTaxAmount;
                        }
                        else {
                            x.value = "";
                        }
                    }

                    return x;
                })
            })
        }
    }

    return (
        <div style={{ position: 'fixed', top: 0, right: 0, background: 'rgba(0, 0, 0, 0.66)', zIndex: 999, width: '100%', height: '100%' }}>
            <Box width="100%" height="100%" flexDirection="row">
                <Box
                    onClick={() => setSelectedItem(undefined)}
                    flexGrow={1}>
                    &nbsp;
                </Box>
                <Box width="1000px" height="100%" alignSelf="flex-end" bg='white'>
                    <Box className="mb-10" flexDirection="row" pl="15px" pr="15px" pt="15px">
                        <Box flexGrow={1} justifyContent="center">
                            <h4 className="m-0 text-black">#{selectedItem.intId} Hareket Detayları - {selectedItem.transactionDateStr}</h4>
                        </Box>
                        <Box justifyContent="center">
                            <i
                                onClick={() => setSelectedItem(undefined)}
                                style={{ fontSize: 18 }} className="actionIcon text-muted fa fa-times"
                            />
                        </Box>
                    </Box>

                    <Box height='100%' overflowY="auto" pl="15px" pr="15px">
                        <div className="row">
                            <div className="col-md-2">
                                <img className="img img-thumbnail" src={selectedItem.bankLogo} />
                            </div>
                            <div className="col-md-10">
                                <h3>{selectedItem.bankName} - {selectedItem.currencyTypeName}</h3>
                                <h5>{selectedItem.bankAccountName}</h5>
                                <h5>{selectedItem.bankAccountIban}</h5>
                                <h2 className="custom-text-right font-weight-bold">{Helpers.correctPrice(selectedItem.amount, 2)} {selectedItem.currencyTypeName}</h2>
                            </div>
                        </div>

                        <hr />

                        {
                            !Helpers.isEmpty(selectedItem.iban) && (
                                <React.Fragment>
                                    <div className="d-flex justify-content-center">
                                        <h2 className='m-0'>{selectedItem.iban}</h2>
                                    </div>
                                    <hr />
                                </React.Fragment>
                            )
                        }

                        {
                            data && (
                                <React.Fragment>
                                    <div className="d-flex">
                                        {
                                            data.customForms.filter(x => !x.parentConstantId).map((item, index) => (
                                                <div style={{ flex: 1 }}>
                                                    <div className="form-check form-check-inline">
                                                        <input onChange={() => getSelectedRadioItems(0)} className="form-check-input" type="radio" name={"inlineRadioOptions-" + item.parentConstantId} id={"inlineRadioOptions-" + item.id} value={item.id} checked={data.selectedIds.includes(item.id)} required />
                                                        <label className="form-check-label" htmlFor={"inlineRadioOptions-" + item.id}>{item.value}</label>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>

                                    {
                                        data.selectedIds.map((outerItem, i) => (
                                            <React.Fragment>
                                                <hr />
                                                <div className="d-flex">
                                                    {
                                                        data.customForms.filter(x => x.parentConstantId == data.selectedIds[i]).map((item, index) => (
                                                            <div style={{ flex: 1 }}>
                                                                <div className="form-check form-check-inline">
                                                                    <input onChange={() => getSelectedRadioItems(i + 1)} className="form-check-input" type="radio" name={"inlineRadioOptions-" + item.parentConstantId} id={"inlineRadioOptions-" + item.id} value={item.id} checked={data.selectedIds.includes(item.id)} required />
                                                                    <label className="form-check-label" htmlFor={"inlineRadioOptions-" + item.id}>{item.value}</label>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </React.Fragment>
                                        ))
                                    }

                                    {
                                        data.customFields.map((item, index) => (
                                            <React.Fragment>
                                                {
                                                    item.dataType == "String" && (
                                                        <div className={index == 0 ? '' : 'mt-5'}>
                                                            <label htmlFor="exampleFormControlInput1" className="form-label required">{item.name}</label>

                                                            <input
                                                                style={{ border: '1px solid #F1F1F4' }}
                                                                onChange={(e) => {
                                                                    setData({
                                                                        ...data,
                                                                        customFields: data.customFields.map(function (x) {
                                                                            if (x.id == item.id)
                                                                                x.value = e.target.value;

                                                                            return x;
                                                                        })
                                                                    })
                                                                }}
                                                                custom-id={"custom-param-" + item.id}
                                                                type="text"
                                                                className="form-control form-control-solid"
                                                                value={item.value}
                                                                required
                                                            />
                                                        </div>
                                                    )
                                                }

                                                {
                                                    item.dataType == "Select" && (
                                                        <div className={index == 0 ? '' : 'mt-5'}>
                                                            <label htmlFor="exampleFormControlInput1" className="form-label required">{item.name}</label>

                                                            <CustomSingleSelect
                                                                onChange={(selectedValue) => onCustomSelectChange(selectedValue, item)}
                                                                selectedValue={item.selectedValue}
                                                                onMenuOpen={async () => {
                                                                    return {
                                                                        isSuccess: true,
                                                                        data: item.items
                                                                    }
                                                                }}
                                                                labelName='label'
                                                                valueName='value'
                                                            />
                                                        </div>
                                                    )
                                                }

                                                {
                                                    item.dataType == "Number" && (
                                                        <div className={(index == 0 ? '' : 'mt-5') + (!customValidate(data.currency.additionalValue1, item.customId) ? " d-none" : "")}>
                                                            <label htmlFor="exampleFormControlInput1" className="form-label required">{item.name}</label>

                                                            <input
                                                                style={{ border: '1px solid #F1F1F4' }}
                                                                onChange={(e) => {
                                                                    setData({
                                                                        ...data,
                                                                        customFields: data.customFields.map(function (x) {
                                                                            if (x.id == item.id)
                                                                                x.value = e.target.value;

                                                                            return x;
                                                                        })
                                                                    })
                                                                }}
                                                                custom-id={"custom-param-" + item.id}
                                                                type="text"
                                                                // onkeypress='validateCustomNumber(event)'
                                                                className="form-control form-control-solid"
                                                                value={item.value}
                                                                required={customValidate(data.currency.additionalValue1, item.customId)}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            </React.Fragment>
                                        ))
                                    }
                                </React.Fragment>
                            )
                        }


                        {/* <div>
                <label htmlFor="exampleFormControlInput1" className="form-label required">Firma</label>
                <input disabled={isJustAddress} style={{ border: '1px solid #F1F1F4' }} value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control form-control-solid" />
            </div> */}

                        {/* <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label required">Adres Türü</label>

                <CustomSingleSelect
                    selectedValue={selectedAddressType}
                    onChange={setSelectedAddressType}
                    insertable={{
                        onSubmit: { code: 'COMPANY_ADDRESS_TYPE' }
                    }}
                    onMenuOpen={() => ConstantService.getConstantList('COMPANY_ADDRESS_TYPE')}
                    labelName='value'
                    valueName='constantId'
                />
            </div> */}

                        {/* <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label required">Açık Adres</label>
                <textarea value={addressText} onChange={(e) => setAddressText(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: 100, resize: 'none' }} className="form-control form-control-solid" />
            </div> */}

                        {/* <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label required">Ülke</label>

                <CustomSingleSelect
                    selectedValue={selectedCountry}
                    onChange={(selectedItem) => {
                        setSelectedCountry(selectedItem);
                        setSelectedCounty(undefined);
                        setSelectedDistrict(undefined);
                        getCompanyAddressByCountryIdAndPostalCode(selectedItem, postalCode);
                    }}
           onMenuOpen={() => CountryService.getCountryList()}
                            labelName='name'
                            valueName='countryId'
                />
            </div> */}

                        {/* <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label required">Posta Kodu</label>
                <input onBlur={() => getCompanyAddressByCountryIdAndPostalCode(selectedCountry, postalCode)} value={postalCode} onChange={(e) => setPostalCode(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
            </div> */}

                        {/* <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label required">Şehir</label>

                <CustomSingleSelect
                    selectedValue={selectedCounty}
                    onChange={(selectedItem) => {
                        setSelectedCounty(selectedItem);
                        setSelectedDistrict(undefined);
                    }}
                    onMenuOpen={selectedCountry ? () => ConstantService.getConstantList('COUNTY', selectedCountry.value) : undefined}
                    labelName='value'
                    valueName='constantId'
                />
            </div> */}

                        {/* <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label required">İlçe</label>

                <CustomSingleSelect
                    selectedValue={selectedDistrict}
                    onChange={setSelectedDistrict}
                    onMenuOpen={selectedCounty ? () => ConstantService.getConstantList('DISTRICT', selectedCounty.value) : undefined}
                    labelName='value'
                    valueName='constantId'
                />
            </div> */}

                        {/* <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label">Yetkili Ad</label>
                <input disabled={isJustAddress} value={authPersonName} onChange={(e) => setAuthPersonName(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
            </div>

            <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label">Yetkili Soyad</label>
                <input disabled={isJustAddress} value={authPersonSurname} onChange={(e) => setAuthPersonSurname(e.target.value)} style={{ border: '1px solid #F1F1F4' }} type={'text'} className="form-control form-control-solid" />
            </div>

            <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label">Yetkili Telefon</label>
                <input disabled={isJustAddress} ref={authPersonPhone1Ref} style={{ border: '1px solid #F1F1F4' }} value={authPersonPhone1} onChange={(e) => setAuthPersonPhone1(e.target.value)} className="form-control form-control-solid" />
            </div>

            <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label">Yetkili E-Posta</label>
                <input style={{ border: '1px solid #F1F1F4' }} value={authPersonEmail} onChange={(e) => setAuthPersonEmail(e.target.value)} type="text" className="form-control form-control-solid" />
            </div> */}

                        {/* <div className="mt-5">
                <label htmlFor="exampleFormControlInput1" className="form-label required">Firma Türü</label>

                <div>
                    <CustomMultiSelect
                        disabled={isJustAddress}
                        onChange={setSelectedFirmTypes}
                        selectedValues={selectedFirmTypes}
                        onMenuOpen={async () => {
                            return {
                                isSuccess: true,
                                data: [
                                    { label: 'Müşteri', value: 'isCustomer' },
                                    { label: 'Tedarikçi', value: 'isSupplier' },
                                    { label: 'Acente', value: 'isAgency' },
                                    { label: 'Gönderici Firma', value: 'isSenderFirm' },
                                    { label: 'Alıcı Firma', value: 'isReceiverFirm' },
                                    { label: 'Gümrük Firması', value: 'isDutyFirm' },
                                    { label: 'Havayolu', value: 'isAirlineFirm' },
                                    { label: 'Denizyolu', value: 'isSeawayFirm' },
                                    // { label: 'Şirket', value: 'isCompany' },
                                ]
                            }
                        }}
                        labelName='label'
                        valueName='value'
                    />
                </div>
            </div> */}
                    </Box>

                    <Box flexDirection="row" justifyContent="flex-end" p="15px">
                        <Box mr="15px">
                            <button
                                className="btn btn-sm btn-light btn-active-light-primary"
                                onClick={() => setSelectedItem(undefined)}
                            >
                                Geri
                            </button>
                        </Box>
                        <Box>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={save}
                            >
                                Kaydet
                            </button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </div >
    )
}

export default BankMovementPopUp;